import { render } from "./VehicleCompareModal.vue?vue&type=template&id=36638b79"
import script from "./VehicleCompareModal.vue?vue&type=script&lang=js"
export * from "./VehicleCompareModal.vue?vue&type=script&lang=js"
script.render = render

export default script